import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Factory, HeartPulse, Pill, Building2, HardHat, Sun, Zap, Wheat, Truck, ConciergeBell, Cpu, Landmark, Sprout, FlaskConical, GraduationCap, Banknote, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

const ICONS = { Factory, HeartPulse, Pill, Building2, HardHat, Sun, Zap, Wheat, Truck, ConciergeBell, Cpu, Landmark, Sprout, FlaskConical, GraduationCap, Banknote };

export default function Industries() {
  const [industries, setIndustries] = useState([]);

  useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14" data-testid="industries-page">
      <p className="gold-kicker mb-3">Industry Ecosystems</p>
      <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-100">EXPLORE THE BUSINESS WORLD.</h1>
      <p className="mt-4 text-slate-400 max-w-2xl">Each industry opens a dedicated ecosystem — companies, buyers, suppliers, requirements, opportunities, market intelligence and AI matches.</p>
      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {industries.map((i) => {
          const Icon = ICONS[i.icon] || Factory;
          return (
            <Link key={i.name} to={`/companies?industry=${encodeURIComponent(i.name)}`} data-testid={`industry-card-${i.name.toLowerCase().replace(/[\s&]+/g, "-")}`}
              className="card-surface p-6 hover:border-gold/50 transition-colors group">
              <Icon size={22} className="text-gold mb-4" />
              <p className="font-display font-semibold text-slate-100 group-hover:text-gold transition-colors">{i.name}</p>
              <p className="text-xs font-mono text-slate-500 mt-2">{i.companies.toLocaleString()} companies</p>
              <p className="text-xs font-mono text-gold mt-0.5">{i.opportunities} live opportunities</p>
              <p className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-slate-400 group-hover:text-gold transition-colors">OPEN ECOSYSTEM <ArrowRight size={12} /></p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
